import GloballyStyledKanban from "./GloballyStyledKanban";

export { GloballyStyledKanban as default };
